import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
    provider: null,
    providers: [],
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    provider(state) {
      return state.provider;
    },
    providers(state) {
      return state.providers;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
      state.provider = null;
      state.providers = [];
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_PROVIDER(state, payload) {
      state.provider = payload;
    },
    SET_PROVIDERS(state, payload) {
      state.providers = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    fetchProvider({ commit }, providerUuid) {
      return new Promise((resolve, reject) => {
        if (!providerUuid)
          reject(new Error("The provider uuid is a required parameter"));
        commit("SET_LOADING", true);
        axios
          .get(`/providers/${providerUuid}`)
          .then((response) => {
            commit("SET_PROVIDER", response.data);
            resolve();
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
    fetchProviders({ commit }, payload = { pagination: false, sort: "asc" }) {
      commit("SET_LOADING", true);

      let url = "/providers?";
      if ("pagination" in payload) url += `pagination=${payload.pagination}`;

      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((response) => {
            commit("SET_PROVIDERS", response.data["hydra:member"]);
            resolve(response);
          })
          .catch((error) => {
            reject(error.response.data);
            // TODO: Log error in Sentry
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
  },
};
